import { CompanyDetailsPage, SettingsPageWrapper } from "@shared/ui/Settings";
import { useParams } from "react-router-dom";
import { EntityType } from "@shared/types/commonTypes";

const CompanyDetails: React.FC = () => {
  const params = useParams<{ eventOrganizerId: string }>();
  const companyId = params.eventOrganizerId!;
  return (
    <SettingsPageWrapper entityType={EntityType.EVENT} entityId={companyId}>
      <CompanyDetailsPage companyId={companyId} />
    </SettingsPageWrapper>
  );
};

export default CompanyDetails;
